import React, { useState, useReducer } from 'react';
import { Box, Typography, Divider, Dialog, IconButton, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AssetsTable from '../../AppGrid/AssetsTable';
import strings from '../../Globalization';
import connectionService from '../../services/Connection';

const AssetsList = () => {
	const [activeRecord, setActiveRecord] = useState(null);
    const [state, setState] = useReducer(
		(prev, next) => (typeof next === 'function' ? { ...prev, ...next(prev) } : { ...prev, ...next }),
		{
			thumbnail: null,
			thumbnailTitle: '',
			thumnailOpen: false
		}
	);
	const handleOnCellClick = ({field, formattedValue, row}) => {
        if (field === 'thumbnail' && !!formattedValue) {
            setState({
				thumbnail: formattedValue,
				thumbnailTitle: row?.assetName || '',
				thumnailOpen: true
			});
		}
        
    };
    
    const handleCloseThumnail = () => {
        setState({
			thumbnail: null,
			thumbnailTitle: '',
			thumnailOpen: false
		});
    }

	return (
		<Box>
			<AssetsTable onCellClick={handleOnCellClick} />
			<Dialog
				open={state.thumnailOpen}
				sx={{
					'& .MuiDialog-paper': {
						width: '80vw'
					}
				}}
				disableEscapeKeyDown
			>
				<DialogTitle sx={{ display: 'flex', flexDirection: 'row' }}>
					<Typography variant="h5" component="div" color="primary" sx={{ flex: 1 }}>
						{state.thumbnailTitle}
					</Typography>
					<IconButton onClick={handleCloseThumnail} color="error" size="small">
						<CloseIcon fontSize="inherit" />
					</IconButton>
				</DialogTitle>
				<Divider />
				<DialogContent>
					<Box component="img" sx={{ width: '100%', height: 'auto' }} src={`${connectionService.Thumbnail}${state.thumbnail}`} />
				</DialogContent>
			</Dialog>
		</Box>
	);
};

export default AssetsList;
